import { AddCircleOutline } from '@mui/icons-material';
import { AlertColor, Box, Button } from '@mui/material';
import strings from 'common/Translation/Translate';
import Notification from 'components/Notification';
import PageLoader from 'components/PageLoader';
import { useCallback, useEffect, useState } from 'react';
import axiosInstance from 'utils/axios';
import { URLS } from 'utils/constants/urls';
import RoomRateMappingRow from './RoomTypeVsCorporateRateRow';

const RoomTypeVsCorporateRate = ({ roomTypeVsCorporateRate, setRoomTypeVsCorporateRate }: any) => {
  const [isLoading, seIstLoading] = useState(false);
  const [roomTypes, setRoomTypes] = useState<any>([]);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [message, setMessage] = useState<{
    display: boolean;
    severity: AlertColor | null;
    message: any;
  }>({
    display: false,
    severity: null,
    message: '',
  });

  const closeNotification = (value: boolean) => {
    setMessage({ ...message, display: value });
  };

  const getRoomType = useCallback(async () => {
    try {
      seIstLoading(true);
      const { data } = await axiosInstance.get(URLS.roomTypeDropdown);
      const filter = data?.map((item: any) => {
        return { ...item, label: item.name, value: item.id };
      });
      setRoomTypes(filter);
    } catch (error: any) {
    } finally {
      seIstLoading(false);
    }
  }, []);

  useEffect(() => {
    getRoomType();
  }, [getRoomType]);

  return (
    <>
      {isLoading && <PageLoader />}
      {message.display && (
        <Notification
          isOpen={message.display}
          message={message.message}
          severity={message.severity as AlertColor}
          closeNotification={closeNotification}
        />
      )}
      <Box width={'100%'}>
        <Button
          data-testid="openForm_btn"
          onClick={() => setOpenForm(true)}
          variant="text"
          sx={{ '.MuiButton-endIcon': { marginLeft: '8px' }, minHeight: '36px', mb: 2, textTransform: 'capitalize' }}
          endIcon={<AddCircleOutline />}>
          {strings.addRoomTypeVsCorporateRate}
        </Button>
      </Box>
      {openForm && (
        <Box mb={2} width={'100%'}>
          <RoomRateMappingRow
            roomTypes={roomTypes}
            pageResponse={{
              roomTypeId: '',
              corporateRate: '',
            }}
            setRoomTypeVsCorporateRate={setRoomTypeVsCorporateRate}
            isAdd={true}
            setOpenForm={setOpenForm}
            roomTypeVsCorporateRate={roomTypeVsCorporateRate}
          />
        </Box>
      )}
      {roomTypeVsCorporateRate?.map((rt: any, idx: any) => (
        <RoomRateMappingRow
          key={rt.roomTypeId}
          roomTypes={roomTypes}
          pageResponse={rt}
          setRoomTypeVsCorporateRate={setRoomTypeVsCorporateRate}
          isAdd={false}
          setOpenForm={setOpenForm}
          idx={rt.roomTypeId}
          roomTypeVsCorporateRate={roomTypeVsCorporateRate}
        />
      ))}
    </>
  );
};
export default RoomTypeVsCorporateRate;
